import { Box, Flex, Spinner } from "@chakra-ui/react";
import { useState } from "react";
import { User } from "../../../definitions/interfaces/Users/Users.interface";
import { appStore } from "../../../zustand/globalStore";
import ModalHeaderComponent from "../../Common/ModalHeaderComponent";
import i18n from "../../../i18n/i18n";
import { steps } from "./container/steps.container";
import BodyText from "../../Common/BodyText";
import { colors } from "../../../definitions/constants/GlobalStyles";
import { RolDirective } from "../../../definitions/enums/GlobalEnums";
import ItemInviteManager from "./components/ItemInviteManager";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase";
import { inviteUserAsTechnicalStaff } from "../../../models/TeamModel";
import CustomMenuSelect from "../../Shared/CustomMenuSelect";
import SearchUser from "../../Common/SearchUser";

const InviteManagers = ({ goToStep, hideContainerModal }): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [rol, setRol] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [users, setUsers] = useState<User[]>([]);
  const [selectUser, setSelectUser] = useState<User | null>(null);
  const { userData, currentTeam, currentTournament } = appStore(
    (store) => store
  );
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const processInvitation = async () => {
    if (selectUser) {
      setLoading(true);
      await inviteUserAsTechnicalStaff(
        userData?.id,
        selectUser?.id,
        currentTournament?.id,
        currentTeam?.id,
        currentTournament?.name,
        currentTeam?.name,
        rol
      );
      setLoading(false);
      goToStep(steps.successInviteTechnicalStaff);
    }
  };

  const handleSearch = async (e) => {
    setSearchText(e.target.value);
    setSearchLoading(true);
    if (searchText.length > 0) {
      const findUsers = await httpsCallable(
        functions,
        "searchUsersByText"
      )({
        filter: `%${searchText.toLocaleLowerCase()}%`,
        userId: userData.id,
        type_user: "user",
      });
      if (findUsers.data) {
        setUsers(findUsers.data as User[]);
      }
    }
    setSearchLoading(false);
  };

  const validateFields = () => {
    const newErrors: { [key: string]: string } = {};
    const fieldsToValidate = [
      {
        key: "rol",
        value: rol,
      },
      {
        key: "selectUser",
        value: selectUser,
      },
    ];

    fieldsToValidate.forEach((field) => {
      if (!field.value) newErrors[field.key] = i18n.t("fieldRequired");
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateFields()) {
      processInvitation();
    } else {
      return;
    }
  };

  return (
    <Flex direction="column" gap={4} width={"100%"} height={"100%"}>
      <ModalHeaderComponent
        title={i18n.t("inviteCoachingStaff")}
        subtitle={i18n.t("get_ready_for_the_tournament")}
        confirmText={i18n.t("invite")}
        onCancel={hideContainerModal}
        onBack={() => goToStep(steps.default)}
        onConfirm={handleSubmit}
        isSaving={loading}
        hasMoreSteps={true}
        actionButtonsRequired={true}
      />
      <Flex
        className="container-inputs"
        direction="column"
        gap={4}
        width={"100%"}
        height={"100%"}
      >
        <CustomMenuSelect
          options={RolDirective}
          labelName={i18n.t("role")}
          error={errors.rol}
          isInvalid={!!errors.rol}
          selectedDescription={rol}
          setSelectedDescription={setRol}
        />
        <SearchUser
          searchText={searchText}
          handleSearch={handleSearch}
          errors={errors}
          label={i18n.t("searchUser")}
          placeholder={i18n.t("searchUser") + "..."}
        />
        <Flex
          className="container-content-users"
          direction="column"
          gap={2}
          width={"100%"}
          height={"100%"}
        >
          <BodyText
            fontSize={{ base: "12px", md: "14px" }}
            fontWeight="regular"
            textColor={colors.text.lightGray3}
          >
            {i18n.t("searchResult")}: {searchText}
          </BodyText>
          {searchLoading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              margin={"20px 0px"}
            >
              <Spinner size="lg" color="blue.500" />
            </Box>
          ) : (
            <Flex direction="column" gap={2}>
              {users.length > 0 &&
                users
                  .slice(0, 3)
                  .map((item) => (
                    <ItemInviteManager
                      item={item}
                      setUser={setSelectUser}
                      userActive={selectUser}
                    />
                  ))}
            </Flex>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default InviteManagers;
